import React, { FC, useEffect, useState } from 'react';
import { Dropdown, Space } from 'antd';
import './language-switcher.scss';
import { MenuProps } from 'antd/lib/menu';
import ArrowIcon from '/react4xp/parts/language-switcher/arrow.svg';
import UserDropdown from '/react4xp/parts/language-switcher/user-dropdown';
import { LanguageSwitcherProps } from '/react4xp/parts/language-switcher/language-switcher.type';

const LanguageSwitcher: FC<LanguageSwitcherProps> = (props: LanguageSwitcherProps) => {
    const items: any = [
        {
            label: 'Русский',
            key: 'ru',
        },
        {
            label: 'Қазақша',
            key: 'kk',
        },
        {
            label: 'English',
            key: 'en',
        }
    ];

    const [lang, setLang] = useState<any>(items[0]);

    const onClick: MenuProps['onClick'] = ({ key }) => {
        if (lang.key !== key) {
            const arr = window.location.href.split('/');
            const index = arr.indexOf(lang.key);

            if (index !== -1) {
                arr[index] = key;
                window.location.href = arr.join('/');
            } else {
                window.location.href = arr.slice(0,3).join('/') + `/${key}/` + arr.slice(3).join('/');
            }
        }
    };

    useEffect(() => {
        const langItem = items.find((x) => x.key === props.language);

        if (langItem) {
            setLang(langItem);
        }
    }, []);

    return (
        <div className="d-flex gap-3 align-items-center">
            <Dropdown
                menu={{ items, onClick }}
                className="language-switcher"
                trigger={['click']}
            >
                <a onClick={(e) => e.preventDefault()}>
                    <Space>
                        {lang && lang.label}
                        <ArrowIcon />
                    </Space>
                </a>
            </Dropdown>
            {props.user && <UserDropdown {...props} />}
        </div>
    );
};

export default LanguageSwitcher;
